import React, { useState, useEffect } from 'react';
import '../../css/bootstrap.min.css';      // Assuming these are in the correct relative path
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css';
// import '../../plugins/datatables/datatables.min.css'; // You might not need DataTables if implementing custom pagination
import axios from 'axios';
import HitkariSidebar from '../Adminsidebar/AdminSidebar'; // Adjust path as needed

function ViewContactSubmissions() {
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // For pagination
    const [searchTerm, setSearchTerm] = useState('');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedSubmission, setSelectedSubmission] = useState(null);

   
    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; 

    useEffect(() => {
        fetchSubmissions();
    }, []);

    const fetchSubmissions = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await axios.get(`${API_BASE_URL}/contactus-submissions`);
            setSubmissions(response.data.submissions || []); // Ensure submissions is an array
        } catch (err) {
            setError("Failed to fetch contact submissions.");
            console.error("Error fetching contact submissions:", err);
            setSubmissions([]); // Set to empty array on error
        } finally {
            setLoading(false);
        }
    };

    // Filter submissions based on search term
    const filteredSubmissions = submissions.filter(submission =>
        (submission.name && submission.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (submission.email && submission.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (submission.subject && submission.subject.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (submission.message && submission.message.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // Calculate items for current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentSubmissions = filteredSubmissions.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredSubmissions.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page
    };

    const handleViewDetails = (submission) => {
        setSelectedSubmission(submission);
        setShowDetailModal(true);
    };

    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setSelectedSubmission(null);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
            return new Date(dateString).toLocaleDateString(undefined, options);
        } catch (e) {
            return dateString; // fallback to original string if date is invalid
        }
    };


    return (
        <>
            <div className="main-wrapper">
                <HitkariSidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">Contact Form Submissions</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/dash">Dashboard</a></li> {/* Adjust link */}
                                        <li className="breadcrumb-item active">Contact Submissions</li>
                                    </ul>
                                </div>
                                {/* Optional: Add button if needed, e.g., export
                                <div className="col-auto">
                                    <button type="button" className="btn btn-primary">
                                        <i className="fas fa-download"></i> Export
                                    </button>
                                </div>
                                */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Received Messages</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by name, email, subject, message..."
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>
                                            <div className="col-md-2">
                                                <select
                                                    className="form-control"
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                >
                                                    <option value="5">5 per page</option>
                                                    <option value="10">10 per page</option>
                                                    <option value="20">20 per page</option>
                                                    <option value="50">50 per page</option>
                                                    <option value="100">100 per page</option>
                                                </select>
                                            </div>
                                        </div>

                                        {loading ? (
                                            <p className="text-center">Loading submissions...</p>
                                        ) : error ? (
                                            <p className="text-center text-danger">{error}</p>
                                        ) : filteredSubmissions.length === 0 ? (
                                            <p className="text-center">No submissions found.</p>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-hover table-center mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Email</th>
                                                            <th>Subject</th>
                                                            <th>Message (Preview)</th>
                                                            <th>Submitted At</th>    
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentSubmissions.map((submission) => (
                                                            <tr key={submission._id}>
                                                                <td>{submission.name}</td>
                                                                <td>{submission.email}</td>
                                                                <td>{submission.subject || 'N/A'}</td>
                                                                <td>{submission.message ? `${submission.message.substring(0, 50)}...` : 'N/A'}</td>
                                                                <td>{formatDate(submission.submittedAt)}</td>
                                                               
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-info"
                                                                        onClick={() => handleViewDetails(submission)}
                                                                    >
                                                                        <i className="far fa-eye"></i> View
                                                                    </button>
                                                                    {/* Optional: Add mark as read/unread button
                                                                    <button className="btn btn-sm btn-secondary ml-1">
                                                                        Mark as {submission.isRead ? 'Unread' : 'Read'}
                                                                    </button>
                                                                    */}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {/* Pagination Controls */}
                                        {totalPages > 1 && !loading && filteredSubmissions.length > 0 && (
                                            <div className="row mt-4">
                                                <div className="col-md-12 d-flex justify-content-center">
                                                    <nav>
                                                        <ul className="pagination">
                                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                                                                    Previous
                                                                </button>
                                                            </li>
                                                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                                                        {page}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                                                                    Next
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* View Detail Modal */}
                    {showDetailModal && selectedSubmission && (
                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="viewDetailModalLabel" aria-hidden="true" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="viewDetailModalLabel">Submission Details</h5>
                                        <button type="button" className="close" onClick={handleCloseDetailModal} aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p><strong>Name:</strong> {selectedSubmission.name}</p>
                                                <p><strong>Email:</strong> {selectedSubmission.email}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Subject:</strong> {selectedSubmission.subject || 'N/A'}</p>
                                                <p><strong>Submitted At:</strong> {formatDate(selectedSubmission.submittedAt)}</p>
                                            </div>
                                        </div>
                                        <hr />
                                        <p><strong>Message:</strong></p>
                                        <p style={{ whiteSpace: 'pre-wrap' }}>{selectedSubmission.message}</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={handleCloseDetailModal}>Close</button>
                                        {/* Optional: Mark as read button inside modal
                                        {!selectedSubmission.isRead && (
                                            <button type="button" className="btn btn-primary" onClick={() => {
                                                // Implement markAsRead(selectedSubmission._id) here
                                                handleCloseDetailModal();
                                            }}>
                                                Mark as Read
                                            </button>
                                        )}
                                        */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default ViewContactSubmissions;